<i18n src="./resources/locales.json"></i18n>
<template>
  <v-card class="email-signature-container ma-2">
    <v-card-title>
      {{ title }}
    </v-card-title>
    <v-card-subtitle>
      {{ subtitle }}
    </v-card-subtitle>
    <v-card-text>
      <EcsQuillEditor
        ref="quill"
        class="quill-editor-container pa-3"
        min-height="300px"
        :value="quillValue"
        :quill-id="quillId"
        @input="onQuillChange"
      />
    </v-card-text>
    <div v-if="quillValue.length === 0" class="error-field mt-2">{{ $t('errorEmpty') }}</div>
  </v-card>
</template>

<script>
import EcsQuillEditor from '@/components/ecs-quill-editor/EcsQuillEditor';

export default {
  name: 'EcsEmailSignature',
  components: { EcsQuillEditor },
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    quillValue: {
      type: String,
      required: true
    },
    onQuillChange: {
      type: Function,
      required: true
    },
    quillId: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.title {
  font-size: 18px;
  display: flex;
  align-items: center;
}
.quill-editor-container {
  background-color: #121212;
}
.error-field {
  font-size: 14px;
  color: var(--v-error-base);
}
.email-signature-container {
  flex-grow: 1;
  flex-basis: 500px;
  min-width: 500px;
}
</style>
